export default __webpack_public_path__ + "static/media/complete.d00f7d5d.png";